import { render, staticRenderFns } from "./AppexChartFormatosProdutos.vue?vue&type=template&id=695bf14c"
import script from "./AppexChartFormatosProdutos.vue?vue&type=script&lang=js"
export * from "./AppexChartFormatosProdutos.vue?vue&type=script&lang=js"
import style0 from "./AppexChartFormatosProdutos.vue?vue&type=style&index=0&id=695bf14c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports